import mock from '@/fake-db/mock.js'

const data = [
	{
		"job_id": 1,
		"status": "verifying",
		"customer_name": "Arsenio",
		"customer_contact": "053-911-4282",
		"address": "303-2099 Lacus, Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2019-12-15 12:08:28",
		"created_at": "2021-04-03 04:23:17",
		"pay_amount": "99 071",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 2,
		"status": "pending",
		"customer_name": "Portia",
		"customer_contact": "039-363-2965",
		"address": "P.O. Box 277, 4078 Ornare Avenue",
		"service_provider": "ecson",
		"scheduled_at": "2020-06-02 07:36:59",
		"created_at": "2020-03-19 09:33:15",
		"pay_amount": "62 594",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 3,
		"status": "verifying",
		"customer_name": "Haviva",
		"customer_contact": "092-745-3309",
		"address": "2875 Magna. St.",
		"service_provider": "daikin",
		"scheduled_at": "2020-08-25 14:50:18",
		"created_at": "2019-11-30 06:55:52",
		"pay_amount": "84 958",
		"pay_method": "cash"
	},
	{
		"job_id": 4,
		"status": "taken",
		"customer_name": "Vaughan",
		"customer_contact": "089-344-1460",
		"address": "8873 Aliquam, Street",
		"service_provider": "daikin",
		"scheduled_at": "2020-10-10 16:14:47",
		"created_at": "2021-04-18 12:42:18",
		"pay_amount": "70 539",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 5,
		"status": "pending",
		"customer_name": "Duncan",
		"customer_contact": "002-630-9217",
		"address": "P.O. Box 148, 7319 Nisi St.",
		"service_provider": "daikin",
		"scheduled_at": "2019-07-06 23:13:49",
		"created_at": "2019-09-20 08:11:54",
		"pay_amount": "13 632",
		"pay_method": "cash"
	},
	{
		"job_id": 6,
		"status": "taken",
		"customer_name": "Lenore",
		"customer_contact": "026-201-9309",
		"address": "617-7674 Varius St.",
		"service_provider": "daikin",
		"scheduled_at": "2019-10-28 11:00:15",
		"created_at": "2020-11-28 01:34:59",
		"pay_amount": "55 363",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 7,
		"status": "verifying",
		"customer_name": "Galvin",
		"customer_contact": "047-384-8470",
		"address": "896-7848 Phasellus Ave",
		"service_provider": "daikin",
		"scheduled_at": "2019-08-17 17:30:32",
		"created_at": "2020-04-04 10:31:02",
		"pay_amount": "82 495",
		"pay_method": "cash"
	},
	{
		"job_id": 8,
		"status": "verifying",
		"customer_name": "Odysseus",
		"customer_contact": "056-387-2968",
		"address": "516-6746 Erat St.",
		"service_provider": "ecson",
		"scheduled_at": "2020-01-08 17:36:58",
		"created_at": "2020-05-27 19:30:04",
		"pay_amount": "10 193",
		"pay_method": "cash"
	},
	{
		"job_id": 9,
		"status": "pending",
		"customer_name": "Joelle",
		"customer_contact": "079-115-0937",
		"address": "222-3576 Volutpat Road",
		"service_provider": "ecson",
		"scheduled_at": "2019-05-09 23:23:56",
		"created_at": "2019-11-03 02:51:32",
		"pay_amount": "93 156",
		"pay_method": "online"
	},
	{
		"job_id": 10,
		"status": "pending",
		"customer_name": "Wyoming",
		"customer_contact": "005-166-4902",
		"address": "703-9357 At Avenue",
		"service_provider": "ecson",
		"scheduled_at": "2019-06-12 09:31:56",
		"created_at": "2020-04-28 01:16:11",
		"pay_amount": "81 212",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 11,
		"status": "pending",
		"customer_name": "Daphne",
		"customer_contact": "043-495-4604",
		"address": "Ap #479-9573 Pellentesque Avenue",
		"service_provider": "ecson",
		"scheduled_at": "2019-10-22 04:26:16",
		"created_at": "2019-11-15 07:10:44",
		"pay_amount": "47 261",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 12,
		"status": "verifying",
		"customer_name": "Summer",
		"customer_contact": "001-145-9255",
		"address": "Ap #410-7001 Nisi. Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2020-02-02 11:04:53",
		"created_at": "2020-01-19 21:59:06",
		"pay_amount": "40 964",
		"pay_method": "cash"
	},
	{
		"job_id": 13,
		"status": "verifying",
		"customer_name": "Jocelyn",
		"customer_contact": "046-600-2261",
		"address": "1422 Ut Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2020-03-06 21:19:38",
		"created_at": "2020-01-27 00:05:49",
		"pay_amount": "96 444",
		"pay_method": "online"
	},
	{
		"job_id": 14,
		"status": "pending",
		"customer_name": "Grant",
		"customer_contact": "029-485-5202",
		"address": "6168 Accumsan Ave",
		"service_provider": "daikin",
		"scheduled_at": "2020-01-08 05:26:36",
		"created_at": "2019-12-04 06:23:41",
		"pay_amount": "51 494",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 15,
		"status": "pending",
		"customer_name": "Quail",
		"customer_contact": "080-464-3906",
		"address": "9073 Ridiculus Street",
		"service_provider": "daikin",
		"scheduled_at": "2021-03-12 16:34:53",
		"created_at": "2019-07-11 21:46:57",
		"pay_amount": "91 211",
		"pay_method": "cash"
	},
	{
		"job_id": 16,
		"status": "verifying",
		"customer_name": "Jordan",
		"customer_contact": "059-331-6394",
		"address": "5470 Nulla Avenue",
		"service_provider": "ecson",
		"scheduled_at": "2019-12-24 06:12:24",
		"created_at": "2020-05-23 17:43:03",
		"pay_amount": "45 498",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 17,
		"status": "verifying",
		"customer_name": "Rhoda",
		"customer_contact": "068-547-6129",
		"address": "589-4080 Ullamcorper. Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2020-03-03 17:26:14",
		"created_at": "2020-12-01 07:45:22",
		"pay_amount": "23 655",
		"pay_method": "online"
	},
	{
		"job_id": 18,
		"status": "taken",
		"customer_name": "Orson",
		"customer_contact": "079-825-6574",
		"address": "838-5556 Sed Av.",
		"service_provider": "daikin",
		"scheduled_at": "2021-03-21 10:15:39",
		"created_at": "2020-03-24 11:45:20",
		"pay_amount": "77 103",
		"pay_method": "online"
	},
	{
		"job_id": 19,
		"status": "pending",
		"customer_name": "Shad",
		"customer_contact": "021-481-5415",
		"address": "P.O. Box 188, 9912 Dui, Street",
		"service_provider": "ecson",
		"scheduled_at": "2020-12-22 14:03:27",
		"created_at": "2020-10-23 15:38:00",
		"pay_amount": "56 769",
		"pay_method": "online"
	},
	{
		"job_id": 20,
		"status": "taken",
		"customer_name": "Kameko",
		"customer_contact": "044-918-5543",
		"address": "1171 Et, Ave",
		"service_provider": "ecson",
		"scheduled_at": "2020-02-10 14:33:20",
		"created_at": "2020-06-02 19:22:12",
		"pay_amount": "71 239",
		"pay_method": "online"
	},
	{
		"job_id": 21,
		"status": "taken",
		"customer_name": "Nyssa",
		"customer_contact": "062-991-8728",
		"address": "180 Ullamcorper, St.",
		"service_provider": "daikin",
		"scheduled_at": "2020-01-08 15:14:59",
		"created_at": "2019-10-26 11:24:24",
		"pay_amount": "58 765",
		"pay_method": "cash"
	},
	{
		"job_id": 22,
		"status": "taken",
		"customer_name": "Jemima",
		"customer_contact": "070-597-2817",
		"address": "Ap #726-8042 Mauris Av.",
		"service_provider": "ecson",
		"scheduled_at": "2021-02-15 06:14:36",
		"created_at": "2019-12-01 03:35:35",
		"pay_amount": "38 516",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 23,
		"status": "taken",
		"customer_name": "Knox",
		"customer_contact": "084-462-0971",
		"address": "512-5266 Senectus Ave",
		"service_provider": "daikin",
		"scheduled_at": "2019-09-23 07:29:13",
		"created_at": "2020-06-30 14:06:48",
		"pay_amount": "99 928",
		"pay_method": "online"
	},
	{
		"job_id": 24,
		"status": "verifying",
		"customer_name": "Marvin",
		"customer_contact": "073-303-3340",
		"address": "P.O. Box 575, 4468 Semper. Av.",
		"service_provider": "daikin",
		"scheduled_at": "2019-09-18 12:53:21",
		"created_at": "2020-12-17 03:22:22",
		"pay_amount": "12 807",
		"pay_method": "online"
	},
	{
		"job_id": 25,
		"status": "pending",
		"customer_name": "Ivor",
		"customer_contact": "054-426-9855",
		"address": "Ap #850-1907 Mauris Ave",
		"service_provider": "daikin",
		"scheduled_at": "2020-02-10 03:04:43",
		"created_at": "2019-12-18 08:23:57",
		"pay_amount": "0 775",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 26,
		"status": "verifying",
		"customer_name": "Kirk",
		"customer_contact": "073-753-1754",
		"address": "5775 Vel, St.",
		"service_provider": "daikin",
		"scheduled_at": "2020-07-10 16:26:54",
		"created_at": "2021-04-07 18:53:28",
		"pay_amount": "6 504",
		"pay_method": "cash"
	},
	{
		"job_id": 27,
		"status": "pending",
		"customer_name": "Brennan",
		"customer_contact": "067-102-9934",
		"address": "Ap #750-4723 Sem. Av.",
		"service_provider": "daikin",
		"scheduled_at": "2019-09-22 09:38:09",
		"created_at": "2021-03-15 06:09:17",
		"pay_amount": "35 547",
		"pay_method": "online"
	},
	{
		"job_id": 28,
		"status": "taken",
		"customer_name": "Evangeline",
		"customer_contact": "015-711-7786",
		"address": "2050 Diam St.",
		"service_provider": "daikin",
		"scheduled_at": "2020-04-25 15:29:58",
		"created_at": "2019-12-15 04:11:57",
		"pay_amount": "11 387",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 29,
		"status": "taken",
		"customer_name": "Perry",
		"customer_contact": "037-929-0015",
		"address": "P.O. Box 262, 4114 Dui. St.",
		"service_provider": "daikin",
		"scheduled_at": "2019-12-14 11:49:43",
		"created_at": "2021-02-09 11:15:00",
		"pay_amount": "27 595",
		"pay_method": "cash"
	},
	{
		"job_id": 30,
		"status": "pending",
		"customer_name": "Oren",
		"customer_contact": "085-839-0153",
		"address": "8196 Suspendisse St.",
		"service_provider": "ecson",
		"scheduled_at": "2019-05-02 15:29:58",
		"created_at": "2019-11-12 14:12:35",
		"pay_amount": "15 173",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 31,
		"status": "verifying",
		"customer_name": "Giacomo",
		"customer_contact": "085-829-1559",
		"address": "8988 Nisi Ave",
		"service_provider": "ecson",
		"scheduled_at": "2019-06-14 18:54:54",
		"created_at": "2020-10-05 02:37:40",
		"pay_amount": "28 916",
		"pay_method": "cash"
	},
	{
		"job_id": 32,
		"status": "taken",
		"customer_name": "Richard",
		"customer_contact": "099-715-3746",
		"address": "P.O. Box 629, 7409 Nulla Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2020-12-26 08:42:59",
		"created_at": "2021-04-16 17:56:31",
		"pay_amount": "65 775",
		"pay_method": "online"
	},
	{
		"job_id": 33,
		"status": "pending",
		"customer_name": "Bernard",
		"customer_contact": "073-748-6237",
		"address": "Ap #952-7183 Donec Street",
		"service_provider": "daikin",
		"scheduled_at": "2019-10-08 11:49:09",
		"created_at": "2020-12-18 21:34:35",
		"pay_amount": "83 592",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 34,
		"status": "taken",
		"customer_name": "Bert",
		"customer_contact": "058-507-6062",
		"address": "P.O. Box 442, 4422 Ut, Road",
		"service_provider": "daikin",
		"scheduled_at": "2020-07-17 14:32:54",
		"created_at": "2020-12-19 15:52:34",
		"pay_amount": "9 501",
		"pay_method": "online"
	},
	{
		"job_id": 35,
		"status": "verifying",
		"customer_name": "Erich",
		"customer_contact": "009-781-3052",
		"address": "P.O. Box 270, 5256 Mollis. Road",
		"service_provider": "ecson",
		"scheduled_at": "2020-08-27 09:45:32",
		"created_at": "2020-04-07 12:27:16",
		"pay_amount": "45 140",
		"pay_method": "cash"
	},
	{
		"job_id": 36,
		"status": "verifying",
		"customer_name": "Isabella",
		"customer_contact": "054-305-2837",
		"address": "7979 Lectus Avenue",
		"service_provider": "daikin",
		"scheduled_at": "2020-12-03 20:12:41",
		"created_at": "2020-11-28 15:06:21",
		"pay_amount": "47 043",
		"pay_method": "online"
	},
	{
		"job_id": 37,
		"status": "taken",
		"customer_name": "Lareina",
		"customer_contact": "002-914-7789",
		"address": "9986 Eu Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2020-05-25 19:13:58",
		"created_at": "2019-07-02 04:19:58",
		"pay_amount": "63 104",
		"pay_method": "cash"
	},
	{
		"job_id": 38,
		"status": "taken",
		"customer_name": "Vladimir",
		"customer_contact": "031-379-6116",
		"address": "2179 Phasellus St.",
		"service_provider": "ecson",
		"scheduled_at": "2020-06-26 17:48:43",
		"created_at": "2019-05-23 09:55:57",
		"pay_amount": "72 037",
		"pay_method": "cash"
	},
	{
		"job_id": 39,
		"status": "pending",
		"customer_name": "Faith",
		"customer_contact": "048-579-6424",
		"address": "461 Risus. St.",
		"service_provider": "ecson",
		"scheduled_at": "2019-10-06 19:25:48",
		"created_at": "2020-03-09 18:42:17",
		"pay_amount": "4 633",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 40,
		"status": "taken",
		"customer_name": "Plato",
		"customer_contact": "078-609-4030",
		"address": "P.O. Box 602, 9393 Quam. Ave",
		"service_provider": "daikin",
		"scheduled_at": "2021-02-08 12:06:09",
		"created_at": "2019-10-28 17:37:02",
		"pay_amount": "68 486",
		"pay_method": "online"
	},
	{
		"job_id": 41,
		"status": "pending",
		"customer_name": "Adrian",
		"customer_contact": "098-079-7496",
		"address": "8043 Mauris, Ave",
		"service_provider": "daikin",
		"scheduled_at": "2020-09-26 05:19:55",
		"created_at": "2020-05-15 23:07:24",
		"pay_amount": "8 727",
		"pay_method": "cash"
	},
	{
		"job_id": 42,
		"status": "pending",
		"customer_name": "Elizabeth",
		"customer_contact": "040-244-5532",
		"address": "Ap #123-5502 A Street",
		"service_provider": "ecson",
		"scheduled_at": "2019-09-14 10:56:20",
		"created_at": "2020-04-10 02:09:03",
		"pay_amount": "57 035",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 43,
		"status": "verifying",
		"customer_name": "Abdul",
		"customer_contact": "017-683-8510",
		"address": "3401 Vulputate Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2019-12-09 00:48:42",
		"created_at": "2021-04-06 09:32:06",
		"pay_amount": "81 600",
		"pay_method": "online"
	},
	{
		"job_id": 44,
		"status": "verifying",
		"customer_name": "Martina",
		"customer_contact": "087-620-0482",
		"address": "795-4899 Tempus, Av.",
		"service_provider": "ecson",
		"scheduled_at": "2019-09-02 15:16:48",
		"created_at": "2020-10-02 22:45:04",
		"pay_amount": "33 013",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 45,
		"status": "taken",
		"customer_name": "Leroy",
		"customer_contact": "002-300-0950",
		"address": "317-6164 Sed, St.",
		"service_provider": "ecson",
		"scheduled_at": "2021-01-25 18:21:21",
		"created_at": "2020-11-02 17:53:20",
		"pay_amount": "30 400",
		"pay_method": "online"
	},
	{
		"job_id": 46,
		"status": "pending",
		"customer_name": "Dale",
		"customer_contact": "046-573-7042",
		"address": "P.O. Box 522, 8477 Tempor St.",
		"service_provider": "daikin",
		"scheduled_at": "2019-05-17 15:02:43",
		"created_at": "2020-09-18 22:16:20",
		"pay_amount": "67 332",
		"pay_method": "cash"
	},
	{
		"job_id": 47,
		"status": "taken",
		"customer_name": "Paki",
		"customer_contact": "008-597-8304",
		"address": "5680 Dictum Av.",
		"service_provider": "ecson",
		"scheduled_at": "2019-08-27 17:35:34",
		"created_at": "2020-09-17 15:56:11",
		"pay_amount": "88 119",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 48,
		"status": "taken",
		"customer_name": "Amy",
		"customer_contact": "059-283-4234",
		"address": "Ap #477-4405 In Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2019-10-06 20:47:22",
		"created_at": "2021-03-17 21:12:22",
		"pay_amount": "65 476",
		"pay_method": "online"
	},
	{
		"job_id": 49,
		"status": "verifying",
		"customer_name": "Brenna",
		"customer_contact": "035-514-6239",
		"address": "9760 Ac Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2020-07-09 21:21:11",
		"created_at": "2019-12-10 17:31:33",
		"pay_amount": "89 009",
		"pay_method": "cash"
	},
	{
		"job_id": 50,
		"status": "verifying",
		"customer_name": "Galvin",
		"customer_contact": "047-816-2005",
		"address": "Ap #994-6140 Eu, St.",
		"service_provider": "ecson",
		"scheduled_at": "2020-09-28 08:41:43",
		"created_at": "2020-10-19 03:38:14",
		"pay_amount": "46 474",
		"pay_method": "online"
	},
	{
		"job_id": 51,
		"status": "taken",
		"customer_name": "Silas",
		"customer_contact": "044-863-3935",
		"address": "P.O. Box 570, 7800 Metus Street",
		"service_provider": "ecson",
		"scheduled_at": "2021-03-14 10:44:28",
		"created_at": "2019-08-09 12:07:56",
		"pay_amount": "35 971",
		"pay_method": "online"
	},
	{
		"job_id": 52,
		"status": "pending",
		"customer_name": "Julie",
		"customer_contact": "009-102-3615",
		"address": "247-8067 Dolor Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2020-12-14 12:02:24",
		"created_at": "2021-03-25 16:58:22",
		"pay_amount": "13 859",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 53,
		"status": "taken",
		"customer_name": "Cheyenne",
		"customer_contact": "004-728-5193",
		"address": "7320 Blandit Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2020-05-19 10:28:42",
		"created_at": "2019-05-20 22:44:12",
		"pay_amount": "68 707",
		"pay_method": "cash"
	},
	{
		"job_id": 54,
		"status": "taken",
		"customer_name": "Stephanie",
		"customer_contact": "080-236-4230",
		"address": "7890 Molestie. Street",
		"service_provider": "ecson",
		"scheduled_at": "2020-05-27 04:12:44",
		"created_at": "2019-06-15 06:33:54",
		"pay_amount": "76 588",
		"pay_method": "cash"
	},
	{
		"job_id": 55,
		"status": "verifying",
		"customer_name": "Alyssa",
		"customer_contact": "010-602-2117",
		"address": "Ap #530-7754 Nulla Road",
		"service_provider": "ecson",
		"scheduled_at": "2020-10-23 02:50:09",
		"created_at": "2020-08-25 10:08:03",
		"pay_amount": "88 276",
		"pay_method": "cash"
	},
	{
		"job_id": 56,
		"status": "pending",
		"customer_name": "Rinah",
		"customer_contact": "005-030-3318",
		"address": "6060 Mauris Avenue",
		"service_provider": "daikin",
		"scheduled_at": "2020-03-15 13:52:03",
		"created_at": "2020-08-01 01:29:31",
		"pay_amount": "10 445",
		"pay_method": "online"
	},
	{
		"job_id": 57,
		"status": "verifying",
		"customer_name": "Daquan",
		"customer_contact": "043-249-3774",
		"address": "259-2304 Eu Street",
		"service_provider": "ecson",
		"scheduled_at": "2021-01-25 02:52:57",
		"created_at": "2019-05-30 04:33:30",
		"pay_amount": "68 847",
		"pay_method": "online"
	},
	{
		"job_id": 58,
		"status": "verifying",
		"customer_name": "Iona",
		"customer_contact": "059-155-6243",
		"address": "8854 Fusce Road",
		"service_provider": "ecson",
		"scheduled_at": "2020-10-13 19:02:56",
		"created_at": "2020-07-05 06:00:50",
		"pay_amount": "61 288",
		"pay_method": "online"
	},
	{
		"job_id": 59,
		"status": "pending",
		"customer_name": "Leilani",
		"customer_contact": "015-125-3270",
		"address": "327-8614 Auctor, St.",
		"service_provider": "ecson",
		"scheduled_at": "2019-08-26 01:09:11",
		"created_at": "2020-06-01 04:04:56",
		"pay_amount": "72 495",
		"pay_method": "online"
	},
	{
		"job_id": 60,
		"status": "taken",
		"customer_name": "Demetrius",
		"customer_contact": "044-793-9214",
		"address": "1937 Lacus. Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2019-06-16 03:09:01",
		"created_at": "2020-10-12 19:13:29",
		"pay_amount": "12 346",
		"pay_method": "cash"
	},
	{
		"job_id": 61,
		"status": "verifying",
		"customer_name": "Martina",
		"customer_contact": "074-150-4424",
		"address": "P.O. Box 247, 7545 Odio St.",
		"service_provider": "daikin",
		"scheduled_at": "2020-03-02 10:02:15",
		"created_at": "2021-03-21 20:37:59",
		"pay_amount": "3 280",
		"pay_method": "cash"
	},
	{
		"job_id": 62,
		"status": "taken",
		"customer_name": "Felicia",
		"customer_contact": "066-171-9932",
		"address": "3750 Malesuada Road",
		"service_provider": "daikin",
		"scheduled_at": "2019-11-05 12:49:03",
		"created_at": "2020-04-29 13:43:26",
		"pay_amount": "50 646",
		"pay_method": "cash"
	},
	{
		"job_id": 63,
		"status": "taken",
		"customer_name": "Edward",
		"customer_contact": "071-255-9383",
		"address": "Ap #350-5115 Orci Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2019-12-10 22:22:14",
		"created_at": "2021-03-15 21:09:20",
		"pay_amount": "87 748",
		"pay_method": "online"
	},
	{
		"job_id": 64,
		"status": "pending",
		"customer_name": "Keaton",
		"customer_contact": "079-978-2188",
		"address": "P.O. Box 986, 7170 Dolor, Ave",
		"service_provider": "daikin",
		"scheduled_at": "2019-05-20 17:31:44",
		"created_at": "2020-11-16 06:56:29",
		"pay_amount": "66 304",
		"pay_method": "cash"
	},
	{
		"job_id": 65,
		"status": "pending",
		"customer_name": "Kitra",
		"customer_contact": "056-342-7141",
		"address": "345-8055 Magna. Street",
		"service_provider": "daikin",
		"scheduled_at": "2020-06-19 17:46:22",
		"created_at": "2020-10-03 20:58:41",
		"pay_amount": "40 337",
		"pay_method": "online"
	},
	{
		"job_id": 66,
		"status": "verifying",
		"customer_name": "Isabella",
		"customer_contact": "023-564-9384",
		"address": "Ap #248-8125 Mi Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2021-04-07 03:20:18",
		"created_at": "2021-03-03 17:08:49",
		"pay_amount": "43 923",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 67,
		"status": "verifying",
		"customer_name": "Orlando",
		"customer_contact": "068-444-3099",
		"address": "P.O. Box 115, 8745 Egestas. St.",
		"service_provider": "ecson",
		"scheduled_at": "2020-04-26 04:08:39",
		"created_at": "2019-06-16 02:47:12",
		"pay_amount": "89 911",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 68,
		"status": "pending",
		"customer_name": "Leo",
		"customer_contact": "054-537-8361",
		"address": "7390 Metus. Road",
		"service_provider": "daikin",
		"scheduled_at": "2020-12-31 20:57:01",
		"created_at": "2019-09-30 10:01:18",
		"pay_amount": "32 222",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 69,
		"status": "taken",
		"customer_name": "Ignacia",
		"customer_contact": "017-250-3919",
		"address": "2835 Interdum. Street",
		"service_provider": "daikin",
		"scheduled_at": "2020-08-16 11:39:23",
		"created_at": "2020-08-15 15:21:17",
		"pay_amount": "1 337",
		"pay_method": "cash"
	},
	{
		"job_id": 70,
		"status": "pending",
		"customer_name": "Lionel",
		"customer_contact": "038-857-6995",
		"address": "Ap #962-2726 Fusce Av.",
		"service_provider": "daikin",
		"scheduled_at": "2020-08-11 23:40:57",
		"created_at": "2019-12-11 11:19:09",
		"pay_amount": "72 602",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 71,
		"status": "taken",
		"customer_name": "Mira",
		"customer_contact": "012-227-0320",
		"address": "249-7568 Pretium Street",
		"service_provider": "daikin",
		"scheduled_at": "2020-10-07 19:17:57",
		"created_at": "2020-01-13 20:45:03",
		"pay_amount": "56 817",
		"pay_method": "cash"
	},
	{
		"job_id": 72,
		"status": "verifying",
		"customer_name": "Keely",
		"customer_contact": "026-398-5851",
		"address": "268-3395 Dolor, Avenue",
		"service_provider": "daikin",
		"scheduled_at": "2020-10-15 03:14:47",
		"created_at": "2021-04-11 02:00:38",
		"pay_amount": "48 519",
		"pay_method": "online"
	},
	{
		"job_id": 73,
		"status": "pending",
		"customer_name": "Caldwell",
		"customer_contact": "068-229-4052",
		"address": "Ap #603-7990 Sem, Street",
		"service_provider": "daikin",
		"scheduled_at": "2019-12-06 08:06:59",
		"created_at": "2020-06-08 01:16:47",
		"pay_amount": "7 805",
		"pay_method": "cash"
	},
	{
		"job_id": 74,
		"status": "verifying",
		"customer_name": "Amber",
		"customer_contact": "011-592-7722",
		"address": "P.O. Box 256, 2463 Pellentesque Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2019-09-20 15:26:24",
		"created_at": "2019-12-19 23:47:38",
		"pay_amount": "4 997",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 75,
		"status": "verifying",
		"customer_name": "Karen",
		"customer_contact": "084-102-2088",
		"address": "316-4109 Neque. Road",
		"service_provider": "ecson",
		"scheduled_at": "2021-03-03 07:23:00",
		"created_at": "2019-11-11 16:47:09",
		"pay_amount": "60 268",
		"pay_method": "cash"
	},
	{
		"job_id": 76,
		"status": "verifying",
		"customer_name": "Leandra",
		"customer_contact": "030-410-9529",
		"address": "Ap #912-3702 Pellentesque Avenue",
		"service_provider": "ecson",
		"scheduled_at": "2020-09-25 12:26:06",
		"created_at": "2020-12-17 17:59:26",
		"pay_amount": "98 858",
		"pay_method": "cash"
	},
	{
		"job_id": 77,
		"status": "taken",
		"customer_name": "Berk",
		"customer_contact": "052-689-9613",
		"address": "P.O. Box 241, 3864 Luctus Ave",
		"service_provider": "ecson",
		"scheduled_at": "2020-09-29 05:12:28",
		"created_at": "2020-10-09 15:59:00",
		"pay_amount": "92 305",
		"pay_method": "cash"
	},
	{
		"job_id": 78,
		"status": "taken",
		"customer_name": "Kai",
		"customer_contact": "089-109-2134",
		"address": "106-5186 Scelerisque Street",
		"service_provider": "ecson",
		"scheduled_at": "2019-12-12 07:51:24",
		"created_at": "2019-04-24 19:26:32",
		"pay_amount": "53 490",
		"pay_method": "cash"
	},
	{
		"job_id": 79,
		"status": "pending",
		"customer_name": "Denton",
		"customer_contact": "073-757-4379",
		"address": "P.O. Box 988, 5300 Donec Avenue",
		"service_provider": "daikin",
		"scheduled_at": "2020-01-04 12:06:04",
		"created_at": "2021-02-04 20:01:32",
		"pay_amount": "32 164",
		"pay_method": "online"
	},
	{
		"job_id": 80,
		"status": "pending",
		"customer_name": "Brittany",
		"customer_contact": "027-934-0768",
		"address": "Ap #913-3141 Non Avenue",
		"service_provider": "ecson",
		"scheduled_at": "2020-04-19 03:30:12",
		"created_at": "2021-01-19 19:52:30",
		"pay_amount": "8 565",
		"pay_method": "online"
	},
	{
		"job_id": 81,
		"status": "taken",
		"customer_name": "Gregory",
		"customer_contact": "077-073-0183",
		"address": "P.O. Box 788, 4597 Adipiscing Road",
		"service_provider": "ecson",
		"scheduled_at": "2020-05-30 11:11:36",
		"created_at": "2020-04-24 10:52:57",
		"pay_amount": "12 420",
		"pay_method": "online"
	},
	{
		"job_id": 82,
		"status": "taken",
		"customer_name": "Jason",
		"customer_contact": "031-199-2341",
		"address": "6904 Ac Av.",
		"service_provider": "ecson",
		"scheduled_at": "2021-03-06 14:32:17",
		"created_at": "2020-05-05 17:08:13",
		"pay_amount": "90 101",
		"pay_method": "cash"
	},
	{
		"job_id": 83,
		"status": "taken",
		"customer_name": "Camden",
		"customer_contact": "061-934-7704",
		"address": "5380 Dui St.",
		"service_provider": "ecson",
		"scheduled_at": "2021-03-18 00:41:56",
		"created_at": "2019-08-01 20:33:21",
		"pay_amount": "79 064",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 84,
		"status": "verifying",
		"customer_name": "Guy",
		"customer_contact": "084-045-6008",
		"address": "P.O. Box 552, 4963 Faucibus Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2021-04-20 01:26:43",
		"created_at": "2021-02-27 16:53:55",
		"pay_amount": "59 389",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 85,
		"status": "taken",
		"customer_name": "Hakeem",
		"customer_contact": "046-974-3601",
		"address": "Ap #141-7819 Ut Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2020-04-03 11:05:21",
		"created_at": "2021-03-23 21:46:34",
		"pay_amount": "87 385",
		"pay_method": "online"
	},
	{
		"job_id": 86,
		"status": "pending",
		"customer_name": "Hammett",
		"customer_contact": "079-954-5521",
		"address": "P.O. Box 242, 4808 Enim. Rd.",
		"service_provider": "ecson",
		"scheduled_at": "2020-10-20 01:47:34",
		"created_at": "2020-10-24 23:05:14",
		"pay_amount": "43 354",
		"pay_method": "online"
	},
	{
		"job_id": 87,
		"status": "verifying",
		"customer_name": "Gay",
		"customer_contact": "007-915-9898",
		"address": "801-385 Dictum. Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2021-02-25 11:23:02",
		"created_at": "2020-07-31 15:11:17",
		"pay_amount": "59 866",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 88,
		"status": "pending",
		"customer_name": "Maia",
		"customer_contact": "088-020-2222",
		"address": "Ap #683-4946 Malesuada Avenue",
		"service_provider": "ecson",
		"scheduled_at": "2020-09-10 11:02:25",
		"created_at": "2020-01-31 02:00:44",
		"pay_amount": "63 908",
		"pay_method": "online"
	},
	{
		"job_id": 89,
		"status": "verifying",
		"customer_name": "Arthur",
		"customer_contact": "056-550-7180",
		"address": "P.O. Box 696, 9315 Ligula St.",
		"service_provider": "daikin",
		"scheduled_at": "2019-05-07 11:04:06",
		"created_at": "2020-01-19 04:48:58",
		"pay_amount": "25 683",
		"pay_method": "online"
	},
	{
		"job_id": 90,
		"status": "pending",
		"customer_name": "Guy",
		"customer_contact": "009-961-8209",
		"address": "699-940 Morbi St.",
		"service_provider": "daikin",
		"scheduled_at": "2019-08-19 14:36:51",
		"created_at": "2019-11-12 06:31:32",
		"pay_amount": "4 561",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 91,
		"status": "pending",
		"customer_name": "Cyrus",
		"customer_contact": "071-727-8940",
		"address": "Ap #867-5435 Molestie Avenue",
		"service_provider": "daikin",
		"scheduled_at": "2019-10-03 08:49:50",
		"created_at": "2019-04-22 05:43:41",
		"pay_amount": "10 074",
		"pay_method": "online"
	},
	{
		"job_id": 92,
		"status": "pending",
		"customer_name": "Justine",
		"customer_contact": "032-810-5136",
		"address": "9482 Ultrices Avenue",
		"service_provider": "daikin",
		"scheduled_at": "2019-10-16 19:22:29",
		"created_at": "2019-12-26 18:11:51",
		"pay_amount": "93 130",
		"pay_method": "cash"
	},
	{
		"job_id": 93,
		"status": "pending",
		"customer_name": "Britanney",
		"customer_contact": "010-299-7402",
		"address": "1066 Diam Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2021-04-07 21:32:28",
		"created_at": "2021-04-11 16:40:27",
		"pay_amount": "33 769",
		"pay_method": "cash"
	},
	{
		"job_id": 94,
		"status": "pending",
		"customer_name": "Cally",
		"customer_contact": "013-377-8488",
		"address": "293-9918 Consequat, St.",
		"service_provider": "daikin",
		"scheduled_at": "2021-03-21 18:26:07",
		"created_at": "2020-08-01 03:28:15",
		"pay_amount": "39 511",
		"pay_method": "cash"
	},
	{
		"job_id": 95,
		"status": "taken",
		"customer_name": "Porter",
		"customer_contact": "027-275-7922",
		"address": "Ap #770-782 Enim Road",
		"service_provider": "ecson",
		"scheduled_at": "2019-12-03 21:09:08",
		"created_at": "2021-01-25 07:19:42",
		"pay_amount": "98 860",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 96,
		"status": "verifying",
		"customer_name": "Sylvester",
		"customer_contact": "074-312-2063",
		"address": "615-1150 Augue. St.",
		"service_provider": "daikin",
		"scheduled_at": "2020-10-24 00:33:01",
		"created_at": "2019-08-05 20:02:33",
		"pay_amount": "47 753",
		"pay_method": "cash"
	},
	{
		"job_id": 97,
		"status": "pending",
		"customer_name": "Jasper",
		"customer_contact": "025-719-1500",
		"address": "369 Facilisis Ave",
		"service_provider": "daikin",
		"scheduled_at": "2019-09-30 09:35:00",
		"created_at": "2020-11-21 06:16:40",
		"pay_amount": "0 225",
		"pay_method": "online"
	},
	{
		"job_id": 98,
		"status": "verifying",
		"customer_name": "Gary",
		"customer_contact": "054-856-1584",
		"address": "516-3288 Aliquam Av.",
		"service_provider": "daikin",
		"scheduled_at": "2020-12-13 19:40:55",
		"created_at": "2019-12-21 08:58:48",
		"pay_amount": "45 633",
		"pay_method": "online"
	},
	{
		"job_id": 99,
		"status": "verifying",
		"customer_name": "Camden",
		"customer_contact": "032-402-0765",
		"address": "8202 Tortor. Rd.",
		"service_provider": "daikin",
		"scheduled_at": "2020-11-05 00:30:18",
		"created_at": "2021-02-19 15:14:09",
		"pay_amount": "84 399",
		"pay_method": "bank_transfer"
	},
	{
		"job_id": 100,
		"status": "verifying",
		"customer_name": "Ruth",
		"customer_contact": "075-712-7641",
		"address": "Ap #585-4921 Mus. Road",
		"service_provider": "ecson",
		"scheduled_at": "2019-07-26 17:35:22",
		"created_at": "2019-04-30 21:58:02",
		"pay_amount": "45 450",
		"pay_method": "online"
	}
]


mock.onGet('/api/service-tickets').reply(() => {
  return [
	  200, 
	  JSON.parse(JSON.stringify(data)).reverse(),
	  { 'x-pagination-page': 1, 'x-pagination-count': 1, 'x-pagination-total': 100, 'x-pagination-page-count': 100 }
	]
})

// POST : Add new Item
mock.onPost('/api/service-tickets/').reply((request) => {

  // Get event from post data
  const item = JSON.parse(request.data).item

  const length = data.length
  let lastIndex = 0
  if (length) {
    lastIndex = data[length - 1].id
  }
  item.id = lastIndex + 1

  data.push(item)

  return [201, {id: item.id}]
})

// Update Product
mock.onPost('/api/service-tickets/').reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const item = data.find((item) => item.id == itemId)
  Object.assign(item, JSON.parse(request.data).item)

  return [200, item]
})

// DELETE: Remove Item
mock.onDelete('/api/service-tickets/').reply((request) => {

  const itemId = request.url.substring(request.url.lastIndexOf('/') + 1)

  const itemIndex = data.findIndex((p) => p.id == itemId)
  data.splice(itemIndex, 1)
  return [200]
})
